var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-input-search',{staticStyle:{"margin-bottom":"24px"},attrs:{"placeholder":"请输入档案编号或使用扫码枪扫描","enter-button":"添加","loading":_vm.loading},on:{"search":_vm.onSearch},model:{value:(_vm.searchValue),callback:function ($$v) {_vm.searchValue=$$v},expression:"searchValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }